// Lightweight registry for Pinia stores using public plugin API
// Keeps a Map of storeId -> store instance so code can lookup stores
// without relying on Pinia internals like `pinia._s`.

import { reactive } from 'vue';

const storeRegistry = reactive(new Map());

export function piniaStoreRegistryPlugin() {
    return ({ store, pinia }) => {
        storeRegistry.set(store.$id, store);
        const origDispose = store.$dispose?.bind(store);
        store.$dispose = (...args) => {
            storeRegistry.delete(store.$id);
            if (typeof origDispose === 'function') {
                origDispose(...args);
            }
            // Pinia only removes from _s, not state.value — clear it so a
            // re-created store with the same id gets a fresh state() call.
            delete pinia.state.value[store.$id];
        };
    };
}

export function getRegisteredStore(id) {
    return storeRegistry.get(id) || null;
}

export function getAllRegisteredStores(pattern = null) {
    if (pattern) {
        const regex = pattern instanceof RegExp ? pattern : new RegExp(pattern);
        return Array.from(storeRegistry.values()).filter(store => regex.test(store.$id));
    }

    return Array.from(storeRegistry.values());
}

export function getStoreInstancesForBrief(pattern = null, briefId) {
    let stores = storeRegistry.values();
    if (pattern) {
        const regex = pattern instanceof RegExp ? pattern : new RegExp(pattern);
        stores = Array.from(stores).filter(store => regex.test(store.$id));
    }
    return Array.from(stores)
        .filter(store => store.projectId === briefId);
}

export default {
    piniaStoreRegistryPlugin,
    getRegisteredStore,
    getAllRegisteredStores,
    getStoreInstancesForBrief,
};
